const IST_TIMEZONE = "Asia/Kolkata";

/** Mon–Fri 9:15–15:30 IST (display only; exchange holidays not included). */
const SESSION_OPEN_MINUTES = 9 * 60 + 15;
const SESSION_CLOSE_MINUTES = 15 * 60 + 30;

/** After this IST time on a weekday, treat same-day NAV as no longer "pending". */
export const NAV_PENDING_CUTOFF_MINUTES = 18 * 60;

const toIstClock = (date) => {
  const localized = date.toLocaleString("en-US", { timeZone: IST_TIMEZONE });
  return new Date(localized);
};

export const getNseDisplaySession = (date = new Date()) => {
  const ist = toIstClock(date);
  const day = ist.getDay();

  if (day === 0 || day === 6) {
    return { isOpen: false, phase: "weekend" };
  }

  const minutes = ist.getHours() * 60 + ist.getMinutes();

  if (minutes < SESSION_OPEN_MINUTES) {
    return { isOpen: false, phase: "pre_open" };
  }
  if (minutes >= SESSION_CLOSE_MINUTES) {
    return { isOpen: false, phase: "post_close" };
  }
  return { isOpen: true, phase: "open" };
};

const formatIstTime = (date) =>
  date.toLocaleString("en-IN", {
    timeZone: IST_TIMEZONE,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

/** Tooltip / status copy for navbar (frontend-only until backend nav_status). */
export const getNavDisplayConfig = (date = new Date()) => {
  const session = getNseDisplaySession(date);
  const asOfTime = formatIstTime(date);
  const istMinutes =
    toIstClock(date).getHours() * 60 + toIstClock(date).getMinutes();

  if (session.phase === "open") {
    return {
      footnote: `As of ${asOfTime} IST · Market open`,
    };
  }

  if (
    session.phase === "post_close" &&
    istMinutes < NAV_PENDING_CUTOFF_MINUTES
  ) {
    return {
      footnote: "Market closed · Today's NAV pending",
    };
  }

  return {
    footnote: "Market closed · As of last business day",
  };
};
